<div fxLayout="column" fxFlexFill style="position: relative">
  <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>
  <div fxFlex="auto" fxFlexFill class="table-container">
    <mat-table [dataSource]="dataSource" [multiTemplateDataRows]=true class="regular-table"
               matSort matSortActive="_id" matSortDirection="desc" matSortDisableClear>

      <ng-container matColumnDef="_id">
        <mat-header-cell *matHeaderCellDef mat-sort-header="_id">Agent #</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <button mat-mini-fab class="no-shadow button-32 users-summary" color="primary" (click)="showUserCallLogsDetails(row)" matTooltip="View Agent Call Logs">
            <mat-icon>group</mat-icon>
          </button>
          {{row._id }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header="name">Agent Name</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.name}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="totalCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header="totalCount">Total Calls</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.totalCount}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="totalIncomingCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header="totalIncomingCount">Total Incoming Calls</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.totalIncomingCount}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="totalIncomingAnswered">
        <mat-header-cell *matHeaderCellDef mat-sort-header="totalIncomingAnswered">Answered Incoming Calls</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.totalIncomingAnswered}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="totalIncomingMissed">
        <mat-header-cell *matHeaderCellDef mat-sort-header="totalIncomingMissed">Missed Incoming Calls</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.totalIncomingMissed}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="totalIncomingMailbox">
        <mat-header-cell *matHeaderCellDef mat-sort-header="totalIncomingMailbox">Mailbox Incoming Calls</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.totalIncomingMailbox}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="totalOutgoingCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header="totalOutgoingCount">Total Outgoing Calls</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.totalOutgoingCount}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="totalOutgoingAnswered">
        <mat-header-cell *matHeaderCellDef mat-sort-header="totalOutgoingAnswered">Connected Outgoing Calls</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.totalOutgoingAnswered}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="totalInternalCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header="totalInternalCount">Total Internal Calls</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.totalInternalCount}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="totalInternalAnswered">
        <mat-header-cell *matHeaderCellDef mat-sort-header="totalInternalAnswered">Answered Internal Calls</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.totalInternalAnswered}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="totalInternalMissed">
        <mat-header-cell *matHeaderCellDef mat-sort-header="totalInternalMissed">Missed Internal Calls</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.totalInternalMissed}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="totalInternalMailbox">
        <mat-header-cell *matHeaderCellDef mat-sort-header="totalInternalMailbox">Mailbox Internal Calls</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.totalInternalMailbox}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="totalTalkDuration">
        <mat-header-cell *matHeaderCellDef mat-sort-header="totalTalkDuration">
          Total Talk Time
          <app-explanation>Outgoing talk time may include the time the outgoing caller spends leaving a voicemail</app-explanation>
        </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.totalTalkDurationFormatted}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="avgTalkDuration">
        <mat-header-cell *matHeaderCellDef mat-sort-header="avgTalkDuration">
          Avg. Talk Time
          <app-explanation>Outgoing talk time may include the time the outgoing caller spends leaving a voicemail</app-explanation>
        </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.avgTalkDurationFormatted}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="totalRingDuration">
        <mat-header-cell *matHeaderCellDef mat-sort-header="totalRingDuration">
          Total Ring Time
          <app-explanation>Includes incoming ring time only</app-explanation>
        </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.totalRingDurationFormatted}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="avgRingDuration">
        <mat-header-cell *matHeaderCellDef mat-sort-header="avgRingDuration">Avg. Ring Time
          <app-explanation>Includes incoming ring time only</app-explanation>
        </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.avgRingDurationFormatted}} </mat-cell>
      </ng-container>
      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
    </mat-table>
  </div>
  <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
</div>
